import classNames from 'classnames'

// import WorkoutOfTheDayHeader from './Header'
import FeaturedContentHeader from '../FeaturedContentHeader'
import Loader from 'content-components/_Primatives/Loader'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'

import style from './style.scss'

type Props = {
  className?: string
  isLoading: boolean
  commentLabelText: string
  commentsCount?: number
  commentsUrl?: string
  headlineText: string
  htmlContent: string
}

function WorkoutOfTheDay({
  className,
  isLoading,
  commentLabelText,
  commentsUrl,
  headlineText,
  commentsCount,
  htmlContent,
}: Props) {
  return isLoading ? (
    <Loader />
  ) : (
    <div className={classNames(style.wrapper, className)}>
      <FeaturedContentHeader
        commentsUrl={commentsUrl}
        commentLabelText={commentLabelText}
        headlineText={headlineText}
        commentsCount={commentsCount}
      />
      <article>
        <TextBlock className={style.textBlock}>{htmlContent}</TextBlock>
      </article>
    </div>
  )
}

export default WorkoutOfTheDay
